import styled from 'styled-components';
  

  
export const Button = styled.div`
   position: fixed; 
   right: 1%;
   bottom: 100px;
   height: 20px;
   font-size: 2.2rem;
   z-index: 1;
   cursor: pointer;
   color: rgb(45 68 77);
   

`